import React from 'react'
import { useLocation } from 'react-router-dom'
import ChannelPage from '../../screens/ChannelPage/ChannelPage.component'

const Channel: React.FC = () => {
  const location = useLocation()
  const { channel } = location.state
  return (<ChannelPage channelId={channel.id} />)
}

export default Channel
